export type DialogTextSegment = { text: string; bold: boolean };

/** Parse simple <strong>...</strong> markup in dialog choice / transcript strings. */
export function parseStrongSegments(raw: string): DialogTextSegment[] {
  const s = String(raw ?? "");
  const parts: DialogTextSegment[] = [];
  const re = /<strong>(.*?)<\/strong>/gi;
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(s)) !== null) {
    if (m.index > last) {
      parts.push({ text: s.slice(last, m.index), bold: false });
    }
    parts.push({ text: m[1] ?? "", bold: true });
    last = m.index + m[0].length;
  }
  if (last < s.length) parts.push({ text: s.slice(last), bold: false });
  return parts.length ? parts : [{ text: s, bold: false }];
}

export function stripDialogMarkup(raw: string): string {
  return String(raw ?? "").replace(/<\/?strong>/gi, "");
}

export function hasDialogMarkup(raw: string): boolean {
  return /<strong>/i.test(String(raw ?? ""));
}
